<template>
    <Confirm>
        <slot />
        <template slot="text">
            <slot name="modal-content" v-bind="this" />
        </template>
        <template slot="modal-footer" slot-scope="{ handleOk, handleCancel }">
            <button class="btn btn-secondary float-right" @click="resetBefore(handleCancel)">Annuler</button>
            <span class="float-right" v-b-tooltip="!hasAcceptedAll ? 'Vous devez accepter les conditions avant de continuer' : ''">
                <button class="btn btn-primary " :disabled="!hasAcceptedAll" @click="handleOk">Valider</button>
            </span>
        </template>
    </Confirm>
</template>

<script>
    import { VBTooltip } from 'bootstrap-vue';
    import Confirm from './Confirm.vue';

    export default {
        components: {
            Confirm
        },
        props: {
            conditionsCount: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                acceptedConditions: []
            }
        },
        computed: {
            hasAcceptedAll() {
                return this.acceptedConditions.length === this.conditionsCount;
            }
        },
        methods: {
            resetBefore(cb) {
                this.acceptedConditions = [];
                cb();
            },
            handleCheckChanged(value) {
                this.acceptedConditions = value;
            }
        },
        directives: {
            'b-tooltip': VBTooltip,
        },
    }
</script>